import { action } from 'typesafe-actions';

import { INews } from 'ApiPackage/NewsModule/interfaces/INews';

import { NewsActionsEnum } from '../enums/NewsActionsEnum';
import { NewsTypesEnum } from '../enums/NewsTypesEnum';

export const newsGetData = (type?: NewsTypesEnum) => action(NewsActionsEnum.NEWS_GET_DATA, { type });
export const newsSetData = (data: INews[], type: NewsTypesEnum) =>
  action(NewsActionsEnum.NEWS_SET_DATA, { data, type });
